import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, Clock } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setState("pending");
      return;
    }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          clearInterval(timer);
        } else if (attempts >= 15) {
          setState("pending");
          clearInterval(timer);
        }
      } catch {
        if (attempts >= 15) {
          setState("pending");
          clearInterval(timer);
        }
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <main className="min-h-screen bg-cream flex items-center justify-center px-5" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center rounded-[2rem] border border-champagne/70 bg-white p-10 shadow-[0_32px_80px_rgb(168,134,27,0.10)]">
        {state === "checking" && (
          <>
            <Loader2 size={44} className="mx-auto text-gold animate-spin" strokeWidth={1.2} />
            <h1 className="mt-6 font-display text-3xl text-ink">Confirming your order…</h1>
            <p className="mt-3 text-sm text-[#5C5C5C]" data-testid="payment-status-text">Just a moment while we confirm your payment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={44} className="mx-auto text-gold-deep" strokeWidth={1.2} />
            <h1 className="mt-6 font-display text-3xl text-ink">Thank you — order confirmed</h1>
            <p className="mt-3 text-sm text-[#5C5C5C] leading-relaxed" data-testid="payment-status-text">
              Your payment was successful. A confirmation will be sent to your email, and your gold eye masks will be on
              their way soon.
            </p>
          </>
        )}
        {state === "pending" && (
          <>
            <Clock size={44} className="mx-auto text-gold" strokeWidth={1.2} />
            <h1 className="mt-6 font-display text-3xl text-ink">Almost there</h1>
            <p className="mt-3 text-sm text-[#5C5C5C] leading-relaxed" data-testid="payment-status-text">
              We are still confirming your payment. If you completed checkout, your confirmation email will arrive
              shortly.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-success-home-link"
          className="mt-8 inline-flex rounded-full bg-ink text-white font-semibold px-8 py-3.5 hover:bg-gold-deep transition-colors duration-300"
        >
          Back to ALIVER
        </Link>
      </div>
    </main>
  );
}
